package com.esoris.kmpmoout.features.expense.expense_form

import com.esoris.kmpmoout.navigation.AppRoute

sealed class ExpenseFormEvent {

    data class OnNavigateTo(val route: AppRoute): ExpenseFormEvent()
    data class OnNavigateBack(val route: AppRoute): ExpenseFormEvent()

    data class OnExpenseFormChange(val expenseForm: ExpenseForm): ExpenseFormEvent()
    data class OnSaveNewExpense(val expenseForm: ExpenseForm): ExpenseFormEvent()

}